// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "../../ExamPage/ExamInstructions.css";
// import { Card } from "@mui/material";
// import ConfirmStartDialog from "../../ExamPage/ConfirmStartDialog.css";
// import GuidedTour from "../GuidedTour";               // adjust path if needed
// import { fullTourSteps } from "../tourSteps"; // or wherever fullTourSteps is defined
// import "../../Final_Css/positiveflowbuttons.css";


// const DummyExamInstructions = ({ onStart, onClose }) => {
//   const [isChecked, setIsChecked] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();


//   const [tourStepIndex, setTourStepIndex] = useState(() => {
//     if (location.state?.resumeTour && typeof location.state.stepIndex === 'number') {
//       return location.state.stepIndex;
//     }
//     return null;   // or  -1   — tour won't show
//   });

//   useEffect(() => {
//     if (location.state?.resumeTour) {
//       navigate(".", { replace: true, state: {} }); // clear state
//     }
//   }, [location.state, navigate]);

//   // ✅ Dummy Instructions (Static)
//   const instructions = [
//     {
//       heading: "General Instructions",
//       points: [
//         "This is a time-bound theory examination.",
//         "Ensure a stable internet connection before starting the exam.",
//         "Do not refresh or close the browser during the exam.",
//         "Any form of malpractice will lead to disqualification."
//       ]
//     },
//     {
//       heading: "Exam Rules",
//       points: [
//         "Each question carries equal marks unless stated otherwise.",
//         "You cannot revisit previous questions once submitted.",
//         "The exam will auto-submit once the timer ends."
//       ]
//     },
//   ];

//   const handleProceed = () => {
//   setLoading(true);

//   // Small delay for better UX (optional but recommended)
//   setTimeout(() => {
//     setLoading(false);

//     // Navigate to the demo dialog route instead of local state
//     navigate("/confirm-startdemodialog");
//   }, 500);
// };

//   const handleConfirmStart = () => {
//     setShowConfirm(false);

//     // Navigate to assignment page (dummy)
//     navigate("/assignment");

//     if (onStart) onStart();
//   };

//   const handleCancelConfirm = () => {
//     setShowConfirm(false);
//   };

//   return (
//     <>

//       {tourStepIndex !== null && tourStepIndex >= 0 && (
//         <GuidedTour
//           steps={fullTourSteps}
//           stepIndex={tourStepIndex}
//           setStepIndex={setTourStepIndex}
//           onFinish={() => setTourStepIndex(null)}
//         />
//       )}
//       <div className="exam-popup-overlay">
//         <Card className="exam-popup-container">
//           <header className="exam-instructions-header">
//             <h2>Theory Exam Instructions</h2>
//           </header>

//           <main className="exam-instructions-body">
//             {instructions.map((section, idx) => (
//               <div key={idx} className="instruction-section">
//                 {section.heading && (
//                   <h3 className="instruction-heading">
//                     {section.heading}
//                   </h3>
//                 )}

//                 <ol className="instruction-list">
//                   {section.points.map((point, i) => (
//                     <li key={i} className="instruction-item">
//                       {point}
//                     </li>
//                   ))}
//                 </ol>
//               </div>
//             ))}

//             {/* Checkbox */}
//             <div className="checkbox-container">
//               <input
//                 type="checkbox"
//                 id="confirm-read"
//                 checked={isChecked}
//                 onChange={() => setIsChecked(!isChecked)}
//                 style={{ accentColor: "var(--theme-accent)" }}
//               />
//               <label htmlFor="confirm-read">
//                 I have read and understood the instructions
//               </label>
//             </div>

//             {/* Buttons */}
//             <div className="buttons-container">
//               <button
//                 className="btn-negative"
//                 onClick={onClose || (() => navigate(-1))}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn"
//                 disabled={!isChecked || loading}
//                 onClick={handleProceed}
//               >
//                 {loading ? "Processing..." : "Proceed"}
//               </button>
//             </div>
//           </main>
//         </Card>
//       </div>

//       {/* Confirmation Dialog */}
//       {showConfirm && (
//         <ConfirmStartDialog
//           loading={loading}
//           onCancel={handleCancelConfirm}
//           onConfirm={handleConfirmStart}
//         />
//       )}
//     </>
//   );
// };

// export default DummyExamInstructions;


// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "../../ExamPage/ExamInstructions.css";
// import { Card } from "@mui/material";
// import GuidedTour from "../GuidedTour";
// import { fullTourSteps } from "../tourSteps";
// import "../../Final_Css/positiveflowbuttons.css";

// // ────────────────────────────────────────────────────────────────
// // Import the DEMO version (we'll use it instead of the original)
// import ConfirmStartDialogDemo from "../UserWelcomeGuide/ConfirmStartDialogDemo";
// //    ↑ adjust path if the file is named differently or located elsewhere
// // ────────────────────────────────────────────────────────────────

// const DummyExamInstructions = ({ onStart, onClose }) => {
//   const [isChecked, setIsChecked] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [tourStepIndex, setTourStepIndex] = useState(() => {
//     if (location.state?.resumeTour && typeof location.state.stepIndex === "number") {
//       return location.state.stepIndex;
//     }
//     return null;
//   });

//   useEffect(() => {
//     if (location.state?.resumeTour) {
//       navigate(".", { replace: true, state: {} });
//     }
//   }, [location.state, navigate]);

//   const instructions = [
//     {
//       heading: "General Instructions",
//       points: [
//         "This is a time-bound theory examination.",
//         "Ensure a stable internet connection before starting the exam.",
//         "Do not refresh or close the browser during the exam.",
//         "Any form of malpractice will lead to disqualification."
//       ]
//     },
//     {
//       heading: "Exam Rules",
//       points: [
//         "Each question carries equal marks unless stated otherwise.",
//         "You cannot revisit previous questions once submitted.",
//         "The exam will auto-submit once the timer ends."
//       ]
//     },
//   ];

//   const handleProceed = () => {
//     console.log("Proceed clicked → setting loading true");
//     setLoading(true);

//     setTimeout(() => {
//       console.log("Delay finished → setting loading false + showConfirm true");
//       setLoading(false);
//       setShowConfirm(true);
//     }, 500);
//   };

//   // Add this inside the component (after all states)
//   useEffect(() => {
//     console.log("showConfirm changed to:", showConfirm);
//   }, [showConfirm]);
//   // Optional: callback when user confirms in the demo dialog
//   const handleDemoConfirm = () => {
//     // You can put real start-exam logic here later
//     console.log("User confirmed start in demo dialog");
//     // Example: navigate("/exam-start") or start exam flow
//     // For now: just close dialog
//     setShowConfirm(false);
//   };

//   const handleDemoCancel = () => {
//     setShowConfirm(false);
//   };

//   return (
//     <>
//       {tourStepIndex !== null && tourStepIndex >= 0 && (
//         <GuidedTour
//           steps={fullTourSteps}
//           stepIndex={tourStepIndex}
//           setStepIndex={setTourStepIndex}
//           onFinish={() => setTourStepIndex(null)}
//         />
//       )}

//       <div className="exam-popup-overlay">
//         <Card className="exam-popup-container">
//           <header className="exam-instructions-header">
//             <h2>Theory Exam Instructions</h2>
//           </header>

//           <main className="exam-instructions-body">
//             {instructions.map((section, idx) => (
//               <div key={idx} className="instruction-section">
//                 {section.heading && (
//                   <h3 className="instruction-heading">{section.heading}</h3>
//                 )}

//                 <ol className="instruction-list">
//                   {section.points.map((point, i) => (
//                     <li key={i} className="instruction-item">{point}</li>
//                   ))}
//                 </ol>
//               </div>
//             ))}

//             {/* Checkbox */}
//             <div className="checkbox-container">
//               <input
//                 type="checkbox"
//                 id="confirm-read"
//                 checked={isChecked}
//                 onChange={() => setIsChecked(!isChecked)}
//                 style={{ accentColor: "var(--theme-accent)" }}
//               />
//               <label htmlFor="confirm-read">
//                 I have read and understood the instructions
//               </label>
//             </div>

//             {/* Buttons */}
//             <div className="buttons-container">
//               <button
//                 className="btn-negative"
//                 onClick={onClose || (() => navigate(-1))}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn"
//                 disabled={!isChecked || loading}
//                 onClick={handleProceed}
//               >
//                 {loading ? "Processing..." : "Proceed"}
//               </button>
//             </div>
//           </main>
//         </Card>
//       </div>

//       {/* Use the DEMO version instead of original */}
//       {showConfirm && (
//         <ConfirmStartDialogDemo
//           open={showConfirm}
//           onConfirm={() => {
//             setShowConfirm(false);
//             console.log("Exam start confirmed");
//           }}
//           onCancel={() => setShowConfirm(false)}
//           loading={loading}
//         />
//       )}
//     </>
//   );
// };

// export default DummyExamInstructions;

import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Card } from "@mui/material";

import "../../ExamPage/ExamInstructions.css";

import "../../Final_Css/positiveflowbuttons.css";

import GuidedTour from "../GuidedTour";

import { fullTourSteps } from "../tourSteps";

// ← Use your original ConfirmStartDialog (not the demo version)

import ConfirmStartDialogDemo from "../UserWelcomeGuide/ConfirmStartDialogDemo"; // Adjust path as needed

const DummyExamInstructions = ({ onStart, onClose }) => {

  const navigate = useNavigate();

  const location = useLocation();

  const [isChecked, setIsChecked] = useState(false);

  const [loading, setLoading] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);

  // Tour handling

  const [tourStepIndex, setTourStepIndex] = useState(() => {

    if (location.state?.resumeTour && typeof location.state.stepIndex === "number") {

      return location.state.stepIndex;

    }

    return null;

  });

  useEffect(() => {

    if (location.state?.resumeTour) {

      navigate(".", { replace: true, state: {} });

    }

  }, [location.state, navigate]);

  const instructions = [

    {

      heading: "General Instructions",

      points: [

        "This is a time-bound theory examination.",

        "Ensure a stable internet connection before starting the exam.",

        "Do not refresh or close the browser during the exam.",

        "Any form of malpractice will lead to disqualification.",

      ],

    },

    {

      heading: "Exam Rules",

      points: [

        "Each question carries equal marks unless stated otherwise.",

        "You cannot revisit previous questions once submitted.",

        "The exam will auto-submit once the timer ends.",

      ],

    },

  ];

  const handleProceed = () => {

    setLoading(true);

    // Small delay (80–150ms) prevents most flickering when showing second overlay

    setTimeout(() => {

      setLoading(false);

      setShowConfirm(true);

    }, 120);

  };

  const handleConfirmStart = () => {
    setShowConfirm(false); // Close dialog

    console.log("User confirmed → starting exam");

    if (onStart) {
      onStart(); // If you have any parent callback
    }

    // Navigate to the exam page
    navigate("/examportal-mock", {
      state: { resumeTour: true, stepIndex: 3 }  // ← Resume at step 4 (0-based index 3: header step)
    }); // ← or whatever your real route is
  };

  const handleConfirmCancel = () => {

    setShowConfirm(false);

  };

  return (
    <>

      {/* Guided Tour */}

      {tourStepIndex !== null && tourStepIndex >= 0 && (
        <GuidedTour

          steps={fullTourSteps}

          stepIndex={tourStepIndex}

          setStepIndex={setTourStepIndex}

          onFinish={() => setTourStepIndex(null)}

        />

      )}

      {/* Instructions Modal */}
      <div className="exam-popup-overlay">
        <Card className="exam-popup-container">
          <header className="exam-instructions-header">
            <h2>Theory Exam Instructions</h2>
          </header>

          <main className="exam-instructions-body">

            {instructions.map((section, idx) => (
              <div key={idx} className="instruction-section">

                {section.heading && (
                  <h3 className="instruction-heading">{section.heading}</h3>

                )}
                <ol className="instruction-list">

                  {section.points.map((point, i) => (
                    <li key={i} className="instruction-item">{point}</li>

                  ))}
                </ol>
              </div>

            ))}

            {/* Checkbox */}
            <div className="checkbox-container">
              <input

                type="checkbox"

                id="confirm-read"

                checked={isChecked}

                onChange={() => setIsChecked(!isChecked)}

                style={{ accentColor: "var(--theme-accent)" }}

              />
              <label htmlFor="confirm-read">

                I have read and understood the instructions
              </label>
            </div>

            {/* Buttons */}
            <div className="buttons-container">
              <button

                className="btn-negative"

                onClick={onClose || (() => navigate(-1))}
              >

                Cancel
              </button>

              <button

                className="btn"

                disabled={!isChecked || loading}

                onClick={handleProceed}
              >

                {loading ? "Processing..." : "Proceed"}
              </button>
            </div>
          </main>
        </Card>
      </div>

      {/* Confirmation Dialog - your original component */}

      {showConfirm && (
        <ConfirmStartDialogDemo

          onConfirm={handleConfirmStart}

          onCancel={handleConfirmCancel}

          loading={loading}

        />

      )}
    </>

  );

};

export default DummyExamInstructions;
